import {
  START_LOADING,
  END_LOADING,
  FETCH_PROFIT_CENTERS,
  FETCH_PROFIT_CENTER,
  ADD_PROFIT_CENTER,
  UPDATE_PROFIT_CENTER,
  DELETE_PROFIT_CENTER,
  PROFIT_CENTERS_ERROR,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  profitCenters: [],
  profitCenter: null,
  error: null,
  numberOfPages: 1,
};

const profitCenters = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true, error: null };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_PROFIT_CENTERS:
      return {
        ...state,
        profitCenters: action.payload.data,
        numberOfPages: action.payload.numberOfPages,
        error: null,
      };
    case FETCH_PROFIT_CENTER:
      return {
        ...state,
        profitCenter: action.payload,
        error: null,
      };
    case ADD_PROFIT_CENTER:
      return {
        ...state,
        profitCenters: [...state.profitCenters, action.payload],
        error: null,
      };
    case UPDATE_PROFIT_CENTER:
      return {
        ...state,
        profitCenters: state.profitCenters.map((profitCenter) =>
          profitCenter._id === action.payload._id ? action.payload : profitCenter
        ),
        error: null,
      };
    case DELETE_PROFIT_CENTER:
      return {
        ...state,
        profitCenters: state.profitCenters.filter(
          (profitCenter) => profitCenter._id !== action.payload
        ),
        error: null,
      };
    case PROFIT_CENTERS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default profitCenters;